<template>
  <v-container id="dashboard" fluid tag="section">
    <div>
      <Memorial v-if="seting_sys.seting_sys_grayscale === '1' || seting_sys.seting_sys_grayscale === 1"/>
    </div>
    <div>
      <welcome />
    </div>

    <ScheduleDashboard />

    <v-container fluid class="section-divider pa-4 pa-md-6 pb-0">
      <v-card flat class="section-divider-card">
        <v-card-text class="d-flex align-center pa-4">
          <div class="section-divider-icon mr-3">
            <v-icon size="24" color="white">mdi-chart-box-outline</v-icon>
          </div>
          <div>
            <div class="section-divider-title">บริการข้อมูล</div>
            <div class="section-divider-subtitle grey--text text--darken-1">
              สถิตินักเรียน นักศึกษา และบุคลากร พร้อมส่งออกข้อมูลเป็น Excel
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-container>

    <v-row>
      <!-- Component Zone -->
      <v-col cols="12" md="12">
        <ReportPerson />
      </v-col>


      <v-col cols="12">
        <personnel_etcSummary />
      </v-col>

      <v-col cols="12">
        <Personnel_etcSummaryBranchsub />
      </v-col>


       <v-col cols="12" md="12">
        <Personnel_etcSummarySubject />
      </v-col>


      <v-col cols="12" md="12">
        <stdsummary />
      </v-col>

      <v-col cols="12" md="12">
        <ReportCollege />
      </v-col>
      <v-col cols="12" md="12">
        <HrApppoint />
      </v-col>
      <v-col cols="12" md="12">
        <ReportBranch />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Bar } from "vue-chartjs";
import FlipCountdown from "vue2-flip-countdown";
import ScheduleDashboard from "./components/core/ScheduleDashboard.vue";

import personnel_etcSummary from "./component/personnel_etcSummary";
import stdsummary from "./component/stdsummary.vue";
import HrApppoint from "./components/core/hrApppoint.vue";
import ReportPerson from "./components/core/reportPerson.vue";
import ReportCollege from "./components/core/reportCollege.vue";
import ReportBranch from "./components/core/reportBranch.vue";
import Personnel_etcSummarySubject from "./component/personnel_etcSummarySubject.vue";
import Personnel_etcSummaryBranchsub from "./component/personnel_etcSummaryBranchsub.vue";
import welcome from "./components/core/welcome.vue";
import Memorial from "./components/memorial.vue";
export default {
  name: "DashboardDashboard",
  extends: Bar,
  components: {
    Memorial,
    FlipCountdown,
    personnel_etcSummary,
    stdsummary,
    ScheduleDashboard,
    HrApppoint,
    ReportPerson,
    ReportCollege,
    ReportBranch,
    Personnel_etcSummarySubject,
    Personnel_etcSummaryBranchsub,
    welcome
  },
  data() {
    return {
      loading: false,
      seting_sys: []

    };
  },
  async mounted() {
    await this.seting_sysQuery();

  },

  methods: {
     async seting_sysQuery() {
      let result = await this.$http.post("seting_sys.php", {
        ApiKey: "HRvec2021",
        seting_sys_id: "1"
      });
      this.seting_sys = result.data;     
    }
  },
  computed: {
    color() {
      return "blue lighten-4";
    }
  }
};
</script>
<style scoped>

#btnnavi {
  width: 50%;
}
.texth2 {
  font-size: xx-large;
  color: yellow;
}

.section-divider {
  max-width: 1200px;
  margin: 0 auto;
}

.section-divider-card {
  border-radius: 14px !important;
  border: 1px solid #e2e8f0 !important;
  background: #ffffff !important;
}

.section-divider-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, #0f766e, #14b8a6);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.section-divider-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
}

.section-divider-subtitle {
  font-size: 0.82rem;
  margin-top: 2px;
}
</style>
